var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'flex justify-start': true,
    'pb-3': _setup.description,
    'pb-4': !_setup.description,
  }},[_c('div',{class:{
      'flex shrink-0 items-center justify-center box-content': true,
      'w-18': !_setup.portrait,
      'w-12 h-12 px-6 pt-5.5': _setup.portrait,
    }},[(_setup.portrait)?_c(_setup.ProcessedImage,{staticClass:"rounded-lg",attrs:{"src":_setup.portrait,"width":_setup.PORTRAIT_SIZE,"height":_setup.PORTRAIT_SIZE,"transforms":{ preset: 'icon', width: _setup.PORTRAIT_SIZE, height: _setup.PORTRAIT_SIZE },"alt":_vm.__('Icon')},nativeOn:{"dblclick":function($event){return _setup.tryModify(_setup.SettingsSubpanel.Icon)}}}):_vm._e()],1),_vm._v(" "),_c('div',{class:{
      'max-w-[85%]': true,
      'mt-5.5': !_setup.description,
      'mt-3': _setup.description,
    }},[_c(_setup.SurfaceBuilder,{class:'text-12-14'}),_vm._v(" "),_c('h1',{class:{
        'mt-0.5': true,
        'min-h-[38px]': !_setup.description,
        [_setup.fontClass]: true,
        'text-surface-title font-semibold break-words whitespace-break-spaces': true,
        'text-dark-text-100': _setup.isMap ? _setup.colorScheme === 'light' : _setup.backgroundLuminance === 'light',
        'text-light-text-100': _setup.isMap ? _setup.colorScheme === 'dark' : _setup.backgroundLuminance === 'dark',
      },attrs:{"data-testid":"surfaceTitle"},domProps:{"textContent":_vm._s(_setup.title || _vm.__('Untitled padlet'))},on:{"dblclick":_setup.handleTitleClick}}),_vm._v(" "),(_setup.description)?_c(_setup.SurfaceTitleDescription,{class:['mt-0.5'],attrs:{"text":_setup.description,"font-id":_setup.fontId,"color-scheme":_setup.isMap ? _setup.colorScheme : _setup.backgroundLuminance},nativeOn:{"dblclick":function($event){return _setup.handleDescriptionClick.apply(null, arguments)}}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }